import React from 'react';
import ReactDatatableComponent from './ReactDatatableComponent';

function Datatable(props) {
    return <ReactDatatableComponent {...props} />;
}

export default Datatable;
